import {Outlet} from "react-router-dom";
import React from "react";

const MenuPlatesLayout = () => {
  return (
    <div className='container flex-grow-1 menu-plates-list'>
      <Outlet />
    </div>
  )
}
export default MenuPlatesLayout
